<template>
  <div class="bt-expansion-panel">
    <template>
      <payment-billet
        v-if="
          billet &&
            !isSpecialCupom &&
            !secondPaymentStep &&
            (productsTotal > 0 || $route.name === 'commissioner') &&
            userProps &&
            userProps.selectedDocument !== 'foreigner' &&
            showBilletPedingOrder
        "
      />
      <payment-card
        v-if="
          interests &&
            !secondPaymentStep &&
            (productsTotal > 0 || $route.name === 'commissioner')
        "
        :interests="interests"
      />
      <payment-pix
        v-if="
          pix &&
            !secondPaymentStep &&
            (productsTotal > 0 || $route.name === 'commissioner') &&
            !isSpecialCupom
        "
      />
      <payment-invoice v-if="invoiceSale" />
      <payment-pix-details
        v-if="secondPaymentStep && pixIsSelected && !isSpecialCupom"
      />
      <payment-ame
        v-if="
          ame &&
            !secondPaymentStep &&
            (productsTotal > 0 || $route.name === 'commissioner') &&
            !isSpecialCupom
        "
      />
      <payment-ame-details
        v-if="secondPaymentStep && ameIsSelected && !isSpecialCupom"
      />
      <payment-paypal
        v-if="
          !secondPaymentStep &&
            (productsTotal > 0 || $route.name === 'commissioner') &&
            paypal &&
            !isSpecialCupom
        "
      />
      <payment-paypal-embedded
        v-if="
          !secondPaymentStep &&
            (productsTotal > 0 || $route.name === 'commissioner') &&
            paypalPlus &&
            !isSpecialCupom
        "
      />
      <div
        class="btn-next-step btn-payment"
        v-if="
          !secondPaymentStep &&
            paymentOption !== 'PPE' &&
            paymentOption !== 'PP'
        "
      >
        <div class="d-flex align-center">
          <v-btn
            v-if="$route.name !== 'commissioner' && !namedOrder"
            round
            outline
            :style="$route.name === 'totem' ? 'height: 45px !important' : ''"
            color="primary"
            style="max-width: 103px"
            depressed
            class="normal-text"
            @click="backAStep"
          >
            Voltar
          </v-btn>
          <v-btn
            block
            round
            depressed
            class="normal-text"
            :style="$route.name === 'totem' ? 'height: 45px !important' : ''"
            :class="{ 'btn-disabled': !canPurchase }"
            :color="canPurchase ? 'primary' : 'info'"
            dark
            @click="purchase"
            >Confirmar</v-btn
          >
        </div>
        <h5
          v-if="
            $route.name !== 'totem' &&
              storeConfigs &&
              storeConfigs.template &&
              storeConfigs.template.termos
          "
          class="checkout-h5 grey--text text-xs-center"
          v-html="storeConfigs.template.termos"
        ></h5>
      </div>
    </template>

    <SecureModal
      :showModal3DS="showModal3DS"
      :data3ds="data3ds"
      :transactionId="transactionId"
      @closeModal="closeSecureModal"
    />
  </div>
</template>

<script>
import moment from 'moment';
import PaymentBillet from './PaymentBillet';
import PaymentCard from './PaymentCard';
import PaymentAme from './PaymentAme';
import PaymentAmeDetails from './PaymentAmeDetails';
import PaymentPaypal from './PaymentPaypal';
import PaymentPaypalEmbedded from './PaymentPaypalEmbedded';
import PaymentPix from './PaymentPix';
import SecureModal from './3DSecure.vue';
import PaymentPixDetails from './PaymentPixDetails.vue';
import { setOptions, bootstrap } from 'vue-gtag';
import { mapGetters } from 'vuex';
import $http from '@/http.js';
import PaymentInvoice from './PaymentInvoice.vue';

export default {
  components: {
    PaymentBillet,
    PaymentPix,
    PaymentCard,
    PaymentAme,
    PaymentAmeDetails,
    PaymentPaypal,
    PaymentPaypalEmbedded,
    PaymentPixDetails,
    SecureModal,
    PaymentInvoice,
  },
  watch: {
    async currentStep(value) {
      if (value === 4) {
        await this.fetchPaymentOptions();
      }
    },
  },
  data() {
    return {
      natalLuzAgency: false,
      showModal3DS: false,
      data3ds: null,
      transactionId: null,
    };
  },
  mounted() {
    if (this.cupomData && this.cupomData.campaign_name === 'Agências') {
      this.natalLuzAgency = true;
    }
    if (this.googleAnalytics) {
      setOptions({
        config: {
          id: `${
            this.isLetter(String(this.googleAnalytics).charAt(0)) ? '' : 'UA-'
          }${this.googleAnalytics}`,
        },
      });
      bootstrap().then(gtag => {
        // all done!
      });
    }
    if (this.productsQuantity > 0 && this.productsTotal === 0) {
      let paymentOption = 'CO';
      this.$store.dispatch('setPaymentOption', paymentOption);
      this.$store.dispatch('setDeliveryOption', 1);
    }
  },
  computed: {
    ...mapGetters([
      'cardNumber',
      'cardName',
      'cardDate',
      'cardCVC',
      'partialError',
      'firstPayment',
      'loginPosData',
      'checkTerms',
      'storeConfigs',
      'invoice',
      'invoiceSale',
      'instalmentAmount',
      'postOrder',
    ]),
    cupomData() {
      return this.$store.getters.cupomData;
    },
    paymentData() {
      return this.$store.getters.paymentData;
    },
    pendingOrder() {
      return this.$store.getters.pendingOrder;
    },
    namedOrder() {
      return this.$store.getters.namedOrder;
    },
    namedOrder() {
      return this.$store.getters.namedOrder;
    },
    keyPagSeguroDev() {
      return this.$store.getters.keyPagSeguroDev;
    },
    keyPagSeguroBetaProd() {
      return this.$store.getters.keyPagSeguroBetaProd;
    },
    eventID() {
      return this.$store.getters.eventID;
    },
    eventName() {
      return this.$store.getters.eventName;
    },
    checkout_dados_nf() {
      return this.$store.getters.checkout_dados_nf;
    },
    body() {
      return this.$store.getters.body;
    },
    userProps() {
      return this.$store.getters.userProps;
    },
    userBilletProps() {
      return this.$store.getters.userBilletProps;
    },
    currentStep() {
      return this.$store.getters.currentStep;
    },
    interests() {
      return this.$store.getters.interests;
    },
    billet() {
      return this.$store.getters.billet;
    },
    ameIsSelected() {
      return this.$store.getters.ameIsSelected;
    },
    pixIsSelected() {
      return this.$store.getters.pixIsSelected;
    },
    secondPaymentStep() {
      return this.$store.getters.secondPaymentStep;
    },
    ame() {
      return this.$store.getters.ame;
    },
    pix() {
      return this.$store.getters.pix;
    },
    paypal() {
      return this.$store.getters.paypal;
    },
    paypalPlus() {
      return this.$store.getters.paypalPlus;
    },
    isSpecialCupom() {
      return this.$store.getters.isSpecialCupom;
    },
    eventID() {
      return this.$store.getters.eventID;
    },
    paymentOption() {
      return this.$store.getters.paymentOption;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    pdv() {
      return this.$store.getters.pdv;
    },
    eventDetails() {
      return this.$store.getters.eventDetails;
    },
    orderData() {
      return this.$store.getters.orderData;
    },
    body() {
      return this.$store.getters.body;
    },
    orderPdvData() {
      return this.$store.getters.orderPdvData;
    },
    showBilletPedingOrder() {
      if (this.$route.name === 'commissioner' && this.orderPdvData) {
        if (this.orderPdvData && this.orderPdvData.valor_pago === 0)
          return true;
        return false;
      }
      if (this.$route.name !== 'commissioner') return true;
      return true;
    },
    productsQuantity() {
      let total = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            total += v.quantidade;
          });
        });
      }
      return total;
    },
    hasProductsCart() {
      let total = 0;
      this.cartProducts.forEach(p => {
        total += p.length;
      });
      return total;
    },
    productsTotal() {
      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total;
    },
    keyPagSeguro() {
      switch (process.env.VUE_APP_ENV) {
        case 'development':
          return this.keyPagSeguroDev;
        case 'homologation':
          return this.keyPagSeguroBetaProd;
        default:
          return this.keyPagSeguroBetaProd;
      }
    },
    tiktokPixel() {
      return this.findTokenPerType('tiktok');
    },
    googleAds() {
      return this.findTokenPerType('google_ads');
    },
    googleAnalytics() {
      return this.findTokenPerType('google_analytics');
    },
    canPurchase() {
      const isBillet = this.paymentOption === 'BB';
      const isCard = this.paymentOption === 'CC';
      const isCourtesy = this.paymentOption === 'CO';
      const isAme = this.paymentOption === 'AME';
      const isPix = this.paymentOption === 'PIX';
      const isInvoice = this.paymentOption === 'INVOICE';
      let hasCardData = false;
      let hasUserProps = false;
      let hasUserBilletProps = false;

      if (
        !this.checkout_dados_nf ||
        this.checkout_dados_nf === 3 ||
        (this.checkout_dados_nf &&
          this.checkout_dados_nf === 4 &&
          !this.invoice)
      ) {
        if (
          this.userProps &&
          this.userProps.name &&
          (this.$route.name !== 'totem' && this.$route.name !== 'commissioner'
            ? this.userProps.email === this.userProps.emailConfirmation
            : this.userProps.email) &&
          this.userProps.phone &&
          this.userProps.document &&
          (this.eventName &&
          this.eventName.includes('Natal Luz') &&
          !this.natalLuzAgency
            ? this.userProps.locationModel
            : true)
        ) {
          if (
            this.userProps.selectedDocument === 'cpf' &&
            this.validateCPF(this.userProps.document)
          )
            hasUserProps = true;
          if (
            this.userProps.selectedDocument === 'cnpj' &&
            this.validateCNPJ(this.userProps.document)
          )
            hasUserProps = true;
          if (
            this.userProps.selectedDocument === 'foreigner' &&
            this.userProps.document
          )
            hasUserProps = true;
        }
      } else if (
        (this.checkout_dados_nf && this.checkout_dados_nf === 1) ||
        (this.checkout_dados_nf && this.checkout_dados_nf === 4 && this.invoice)
      ) {
        if (
          this.userProps &&
          this.userProps.name &&
          this.userProps.email === this.userProps.emailConfirmation &&
          this.userProps.phone &&
          this.userProps.document &&
          this.userProps.cep &&
          this.userProps.address &&
          this.userProps.number &&
          this.userProps.neighborhood &&
          this.userProps.city &&
          this.userProps.state &&
          this.userProps.country
        ) {
          if (
            this.userProps.selectedDocument === 'cpf' &&
            this.validateCPF(this.userProps.document)
          )
            hasUserProps = true;
          if (
            this.userProps.selectedDocument === 'cnpj' &&
            this.validateCNPJ(this.userProps.document)
          )
            hasUserProps = true;
          if (
            this.userProps.selectedDocument === 'foreigner' &&
            this.userProps.document
          )
            hasUserProps = true;
        }
      } else if (this.checkout_dados_nf && this.checkout_dados_nf === 2) {
        if (
          this.userProps &&
          this.userProps.name &&
          this.userProps.email === this.userProps.emailConfirmation &&
          this.userProps.phone &&
          this.userProps.document &&
          (this.userProps.selectedDocument &&
          this.userProps.selectedDocument !== 'foreigner'
            ? this.userProps.locationModel
            : true)
        ) {
          if (
            this.userProps.selectedDocument === 'cpf' &&
            this.validateCPF(this.userProps.document)
          )
            hasUserProps = true;
          if (
            this.userProps.selectedDocument === 'cnpj' &&
            this.validateCNPJ(this.userProps.document)
          )
            hasUserProps = true;
          if (
            this.userProps.selectedDocument === 'foreigner' &&
            this.userProps.document
          )
            hasUserProps = true;
        }
      }

      if (
        this.userBilletProps &&
        this.userBilletProps.payer_name &&
        this.userBilletProps.payer_doc &&
        this.userBilletProps.selectedDocument
      ) {
        if (
          this.userBilletProps.selectedDocument === 'cpf' &&
          this.validateCPF(this.userBilletProps.payer_doc)
        )
          hasUserBilletProps = true;
        if (
          this.userBilletProps.selectedDocument === 'cnpj' &&
          this.validateCNPJ(this.userBilletProps.payer_doc)
        )
          hasUserBilletProps = true;
        if (
          this.userBilletProps.selectedDocument === 'foreigner' &&
          this.userBilletProps.payer_doc
        )
          hasUserBilletProps = true;
      }

      if (this.pendingOrder && !this.firstPayment) hasUserProps = true;

      if (
        this.eventDetails &&
        this.eventDetails.politica_compra &&
        !this.checkTerms
      )
        return false;

      if (isCard) {
        const { cardName } = this.$store.getters;
        const { cardNumber } = this.$store.getters;
        const { cardDate } = this.$store.getters;
        // const cardCPF = this.validateCPF(this.$store.getters.cardCPF);
        const { cardCVC } = this.$store.getters;
        const { instalmentAmount } = this.$store.getters;

        if (
          (cardName && cardNumber && cardDate && cardCVC && instalmentAmount) ||
          this.$route.name === 'totem'
        ) {
          hasCardData = true;
        }
      }
      return (
        ((isBillet && hasUserBilletProps) ||
          isCourtesy ||
          isAme ||
          isPix ||
          isInvoice ||
          (isCard && hasCardData)) &&
        !this.$store.getters.purchaseStarted &&
        hasUserProps &&
        !this.partialError
      );
    },
  },
  methods: {
    async fetchPaymentOptions() {
      const { eventID, pdv } = this.$store.getters;
      // const total = this.$store.getters.productsTotal;
      await this.$store.dispatch('fetchPaymentOptions', {
        eventID,
        pdv: pdv,
        total: this.productsTotal,
        commissioner: this.$route.name === 'commissioner',
      });
    },
    isLetter(str) {
      return /[a-zA-Z]/.test(str);
    },
    backAStep() {
      if (this.$route.name === 'totem') this.$store.dispatch('backAStep');
      this.$store.dispatch('backAStep');
    },
    gAnalytics() {
      let products = [];
      this.cartProducts.forEach(item => {
        item.forEach(p => {
          let product = {
            id: `${this.eventID}-${this.body.codigo_pedido}`,
            name: `${this.eventName} - ${p.nome}`,
            sku: String(p.codigo_produto),
            category: 'Evento',
            price: p.valor,
            quantity: p.quantidade,
          };
          products.push(product);
        });
      });
      this.$gtag.purchase({
        transaction_id: `${this.eventID}-${this.body.codigo_pedido}`,
        affiliation: this.eventName,
        value: this.productsTotal,
        currency: 'BRL',
        items: products,
      });

      if (this.storeConfigs.googleAnalytics) {
        this.$gtag.purchase({
          transaction_id: `${this.eventID}-${this.body.codigo_pedido}`,
          affiliation: this.eventName,
          value: this.productsTotal,
          currency: 'BRL',
          items: products,
          send_to: this.storeConfigs.googleAnalytics,
        });
      }
    },
    async purchaseTotem() {
      let products = [];
      this.cartProducts.forEach(item => {
        item.forEach(p => {
          products.push({
            name: p.nome,
            price: p.valor,
            qt: p.quantidade,
            un: 'UN',
            ICMS: 0,
          });
        });
      });
      await this.$store
        .dispatch('paymentTotem', {
          paymentMethod: 'credit',
          saleItems: products,
          nrCoupon: String(this.body.codigo_pedido),
          fiscalHour: moment().format('HH:mm:ss'),
          fiscalDate: moment().format('YYYY-MM-DD'),
          operator: 'Terminal Blueticket 01',
          total: this.productsTotal,
        })
        .then(response => {
          if (response && response.success) {
            this.registerPayment(response);
          }
        });
    },
    async registerPayment(response) {
      this.$store.dispatch('nextStep');
      this.$store.commit('SET_PRINT_TICKETS', true);
      await this.$store
        .dispatch('registerPayment', {
          event: this.eventID,
          order: this.body.codigo_pedido,
          payment_option: 'CC',
          tid: response.transfer.sitef_nsu,
          transaction_code: response.transfer.sitef_nsu,
          transaction_id: response.transfer.host_nsu,
          installments: 1,
          interest: 0,
        })
        .then(async resp => {
          if (resp && resp.data && !resp.data.error)
            await this.$store.dispatch('confirmOrder', true);
        });
    },
    async startGtag() {
      this.$gtag.event('Compra', {
        send_to: `${
          this.isLetter(String(this.googleAnalytics).charAt(0)) ? '' : 'UA-'
        }${this.googleAnalytics}`,
        transaction_id: `${this.eventID}-${this.body.codigo_pedido}`,
        event_category: 'ecommerce',
        event_label: 'Total',
        value: this.productsTotal,
        event_value: this.productsTotal,
      });

      if (this.storeConfigs.googleAnalytics) {
        this.$gtag.event('Compra', {
          send_to: this.storeConfigs.googleAnalytics,
          transaction_id: `${this.eventID}-${this.body.codigo_pedido}`,
          event_category: 'ecommerce',
          event_label: 'Total',
          value: this.productsTotal,
          event_value: this.productsTotal,
        });
      }
    },
    tiktokAnalytics() {
      window.ttq.track('CompletePayment', {
        product_group: 'product_group',
        content_id: `${this.eventID}-${this.body.codigo_pedido}`,
        content_category: 'ecommerce',
        value: this.productsTotal,
        description: 'Total',
        currency: 'BRL',
      });
    },
    findTokenPerType(type) {
      return this.eventDetails &&
        this.eventDetails.integracoes_publicas &&
        this.eventDetails.integracoes_publicas.find(i => i.tipo === type)
        ? this.eventDetails.integracoes_publicas.find(i => i.tipo === type)
            .credenciais.token
        : '';
    },

    async checkPurchaseStatus() {
      let headers = { checkout: 'one-checkout' };

      const {
        data,
      } = await $http.get(
        `pdv/orders/charge/status?order_hash=${this.body.codigo_pedido}`,
        null,
        { headers }
      );

      if (data && (data.status === 'paid' || data.status === 'in_process')) {
        const postOrder = {
          ...this.postOrder,
          organizador: data.orderData.nome_organizador,
          cpf_organizador: data.orderData.org_cpf,
          cnpj_organizador: data.orderData.org_cnpj,
          mensagem: data.orderData.mensagem_conclusao_pedido,
          status: data.status === 'paid' ? 'Aprovado' : 'Em análise',
          card: ` no cartão terminado em ${this.cardNumber.substr(
            this.cardNumber.length - 4
          )}`,
          instalments: `em ${this.instalmentAmount}x`,
          hash_pedido: this.body.hash_pedido,
          payment: 'CC',
        };

        this.$store.dispatch('setPostOrder', postOrder);
        this.$store.commit('SET_TICKET_URL', data.orderData.ticketsUrl);
        this.$store.dispatch('setBody', {
          ...this.$store.getters.body,
          expiration: 0,
        });
        console.log('setPurchaseStarted - pixOrderStatus - false');
        this.$store.dispatch('setPurchaseStarted', false);
        localStorage.setItem('iframePurcheased', true);
        this.$store.dispatch('nextStep');
        this.$store.commit('SET_ORDER_DATA', data);
      } else {
        this.$store.dispatch('openSnackbar', {
          message: 'Error ao validar',
          color: 'error',
        });
      }
    },

    open3DSMercadoPago(data) {
      this.transactionId = data.tid;
      this.data3ds = data.challenge;
      this.showModal3DS = true;
      this.$store.dispatch('setPurchaseStarted', false);
      this.$store.dispatch('subtractLoading');
      this.$store.commit('SET_SECURE_3DS_OPEN', true);
    },

    closeSecureModal(paid) {
      this.showModal3DS = false;
      this.$store.commit('SET_SECURE_3DS_OPEN', false);
    },

    async purchase() {
      try {
        if (this.canPurchase) {
          if (this.paymentOption === 'CC') {
            if (this.$route.name === 'totem') {
              this.purchaseTotem();
            } else {
              localStorage.setItem('iframePurcheased', true);
              this.$store.dispatch('setPurchaseStarted', true);

              // ATTENTION: Never change the value of this variable because there are conditions in the card request A
              let params = null;

              if (this.paymentData.credit_card_gateway === 'PAGSEGURO') {
                params = this.encryptCardPagSeguro();
              }

              if (this.paymentData.credit_card_gateway === 'MERCADO-PAGO') {
                params = await this.encryptCardMercadoPago();
              }

              const resp = await this.$store.dispatch('chargeCard', params);

              if (resp && resp.status && resp.status === '3ds') {
                if (
                  resp &&
                  resp.challenge &&
                  resp.challenge.status === 'pending_challenge'
                )
                  this.open3DSMercadoPago(resp);
                else this.checkPurchaseStatus();
              }
            }
          } else if (this.paymentOption === 'BB') {
            localStorage.setItem('iframePurcheased', true);
            this.$store.dispatch('setPurchaseStarted', true);
            await this.$store.dispatch('chargeBillet');
          } else if (this.paymentOption === 'CO') {
            await this.$store.dispatch('chargeCourtesy');
          } else if (this.paymentOption === 'AME') {
            this.$store.commit('SET_SECOND_PAYMENT_STEP', true);
            this.$store.commit('SET_AME_SELECTED', true);
            await this.$store.dispatch('chargeAme');
          } else if (this.paymentOption === 'PIX') {
            this.$store.commit('SET_SECOND_PAYMENT_STEP', true);
            this.$store.commit('SET_PIX_SELECTED', true);
            await this.$store.dispatch('chargePix');
          } else if (this.paymentOption === 'INVOICE') {
            localStorage.setItem('iframePurcheased', true);
            this.$store.dispatch('setPurchaseStarted', true);
            await this.$store.dispatch('chargeInvoice');
          }

          this.gAnalytics();

          if (this.eventDetails && this.googleAnalytics) this.startGtag();

          if (this.tiktokPixel) this.tiktokAnalytics();
        }
      } catch (e) {
        this.$store.dispatch('setPurchaseStarted', false);
      }
    },

    encryptCardPagSeguro() {
      let params = null;

      let card = PagSeguro.encryptCard({
        publicKey: this.keyPagSeguro,
        holder: this.cardName,
        number: this.cardNumber,
        expMonth: this.cardDate.slice(0, 2),
        expYear: `20${this.cardDate.slice(2)}`,
        securityCode: this.cardCVC,
      });
      var md5 = require('md5');
      let encrypted = card.encryptedCard;
      params = {
        card_encrypted: encrypted,
        card_hash: `${this.cardNumber.slice(0, 6)}******${this.cardNumber.slice(
          12
        )}`,
        card_hash_full: md5(this.cardNumber).replaceAll(' ', '$0u1BT'),
      };

      return params;
    },

    async encryptCardMercadoPago() {
      const mp = new window.MercadoPago(this.paymentData.credit_card_tokenizer);

      const { results } = await mp.getPaymentMethods({
        bin: String(this.cardNumber.slice(0, 8)),
      });

      const paymentMethod = results[0];

      const typeDocument =
        this.userProps.selectedDocument === 'cpf' ||
        this.userProps.selectedDocument === 'cpnj'
          ? this.userProps.selectedDocument.toUpperCase()
          : '';

      let numberDocument = '';

      if (
        this.userProps.selectedDocument === 'cpf' ||
        this.userProps.selectedDocument === 'cpnj'
      )
        numberDocument = this.userProps.document.replace(/\D/g, '');

      const token = await mp.createCardToken({
        cardholderName: this.cardName,
        cardNumber: this.cardNumber,
        securityCode: this.cardCVC,
        cardExpirationMonth: this.cardDate.slice(0, 2),
        cardExpirationYear: `20${this.cardDate.slice(2)}`,
        identificationType: typeDocument,
        identificationNumber: numberDocument,
      });

      var md5 = require('md5');

      let params = {
        card_encrypted: token.id,
        card_hash: `${this.cardNumber.slice(0, 6)}******${this.cardNumber.slice(
          12
        )}`,
        card_hash_full: md5(this.cardNumber).replaceAll(' ', '$0u1BT'),
        card_brand: paymentMethod.id,
      };

      return params;
    },

    validateCNPJ(cnpj) {
      if (cnpj && cnpj.length) {
        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj === '') return false;

        if (cnpj.length !== 14) return false;

        // Elimina CNPJs invalidos conhecidos
        if (
          cnpj === '00000000000000' ||
          cnpj === '11111111111111' ||
          cnpj === '22222222222222' ||
          cnpj === '33333333333333' ||
          cnpj === '44444444444444' ||
          cnpj === '55555555555555' ||
          cnpj === '66666666666666' ||
          cnpj === '77777777777777' ||
          cnpj === '88888888888888' ||
          cnpj === '99999999999999'
        )
          return false;

        // Valida DVs
        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (parseInt(resultado) !== parseInt(digitos.charAt(0))) return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (parseInt(resultado) !== parseInt(digitos.charAt(1))) return false;

        return true;
      } else {
        return false;
      }
    },
    validateCPF(cpf) {
      let numeros;
      let digitos;
      let soma;
      let i;
      let resultado;
      let digitosIguais;
      digitosIguais = 1;
      cpf = cpf.replace(/-|\./g, '');
      if (cpf.length < 11) {
        return false;
      }
      for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
          digitosIguais = 0;
          break;
        }
      }
      if (!digitosIguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) {
          soma += numeros.charAt(10 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) {
          return false;
        }
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) {
          soma += numeros.charAt(11 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(1))) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/payment/paymentOptions.styl';
</style>
